import SingleSelection from '../../../../dataViews/NextTree/plugins/SingleSelection';

export default {
  makeTreePlugin: canSelectNode =>
    new SingleSelection({ nodeIsSelectable: canSelectNode }),
};
